/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum UserLanguage {
  NlNL = "nl_NL",
  EnUS = "en_US",
  Fr = "fr",
  De = "de",
  It = "it",
  ItCH = "it_CH",
  NlBE = "nl_BE",
  FrBE = "fr_BE",
  DeAT = "de_AT",
  DeCH = "de_CH",
  FrCH = "fr_CH",
}

export interface CaptchedMeterReadingRequest {
  /** The puzzle solution token from the requesting form */
  captcha: string;
  /**
   * @min 1
   * @max 2
   */
  fileAmount?: number;
  customer: {
    salesOrganizationId?: string;
    distributionChannel?: string;
    email: string;
    branch?: string;
    ERPCustomerId: string;
  };
  meterReading: {
    reason:
      | "METER_INSTALLATION"
      | "MOVE_IN"
      | "BILLING"
      | "PRICE_CHANGE"
      | "MOVE_OUT"
      | "OTHER"
      | "EXTRACTION"
      | "METER_REMOVAL"
      | "TAX_CHANGE";
    /** @format date-time */
    datetime?: string;
    /** @format date */
    date?: string;
    meterNumber?: string;
    contractNumber?: string;
    mode?: "PHONE" | "PORTAL";
    value: number;
    currentFillLevelPercentage?: number;
  };
  dataConfirmed?: boolean;
}

/** A record was created successfully. The record is returned in the data property of the body. */
export interface RecordCreated {
  correlationId: string;
  data: object;
  /**
   * @min 200
   * @max 299
   * @default 201
   */
  status: number;
}

/** structure for external errors. */
export interface Type {
  /** A short, human-readable summary of the problem type.  It SHOULD NOT change from occurrence to occurrence of the problem, except for purposes of localization (e.g., using proactive content negotiation; see [RFC7231], Section 3.4). */
  title: string;
  correlationId: string;
  /** A human-readable explanation specific to this occurrence of the problem. */
  detail: string;
  /**
   * A URI reference [RFC3986] that identifies the problem type.  This specification encourages that, when dereferenced, it provide human-readable documentation for the problem type (e.g., using HTML [W3C.REC-html5-20141028]).  When this member is not present, its value is assumed to be "about:blank"
   * @default "about:blank"
   */
  type: string;
  /**
   * @min 100
   * @max 599
   */
  status: number;
}

export interface RegistrationRequest {
  captcha: string;
  channel: "FBS" | "GAS";
  name1: string;
  language: UserLanguage;
  email: string;
  function?: string;
  salutation: "Mr." | "Ms." | "Mx.";
  telephoneNumber?: string;
  name2: string;
  ERPCustomerId: string;
  referenceNumber: string;
}

/** @example {"accountId":"2093920203","contactId":"4039403","userId":"23049304"} */
export interface RegistrationResponse {
  accountId: string;
  contactId: string;
  userId: string;
}

export interface RegistrationValidationsRequest {
  channel: "FBS" | "GAS";
  email: string;
  ERPCustomerId: string;
  referenceNumber?: string;
}

/** Action posted without generating a new record */
export interface ActionPostedWithoutNewRecord {
  correlationId: string;
  message: string;
  /**
   * @min 200
   * @max 299
   * @default 201
   */
  status: number;
}

export interface ProductSearchResponseType {
  /** @minItems 0 */
  products: Items[];
}

export interface ProductCategoriesResponse {
  /** @minItems 0 */
  categories: ProductCategoriesType[];
}

export interface ProductSubstancesResponseType {
  /** @minItems 0 */
  productSubstances: Items1[];
}

export interface CatalogueProductDetailsType {
  productId: string;
  externalId: string;
  productCode: string;
  productClass?: string;
  name?: string;
  customName?: string;
  description?: string;
  /** @minItems 0 */
  imageURLs?: Items2[];
  previewText?: string;
  summary?: string;
  importantInformation?: string;
  typicalApplication?: string;
  fillingConditions?: string;
  properties?: string;
  bottleShoulderColor?: string;
  state?: string;
  purity?: number;
  typicalApplications?: string;
  refrigerantDivisions?: string;
  norm?: string;
  normAdditions?: string;
  isVisible?: boolean;
  isBuyable?: boolean;
  gasTypeHardware?: string;
  material?: string;
  controlRange?: string;
  connection?: string;
  output?: string;
  certificate?: string;
  container?: string;
  mixtureType?: string;
  bottleType?: string;
  fillingSeason?: string;
  volume?: number;
  manufacturingPrecision?: number;
  stability?: number;
  fillingConnection?: string;
  valveMaterial?: string;
  fillingPressure?: string;
  fillingCapacity?: number;
  valvePrimary?: string;
  valveSecondary?: string;
  inGGStock?: boolean;
  categories?: Items3[];
  translations?: Items4[];
  /** @minItems 0 */
  characteristics: Items5[];
  /** @minItems 0 */
  components?: Items6[];
  residualGas?: Items1;
  /** @minItems 0 */
  variants?: {
    productId: string;
    externalId?: string;
    productCode?: string;
    productClass?: string;
    customName?: string;
    /** @minItems 0 */
    imageURLs?: Items2[];
    bottleType?: string;
    bottleCharacteristics?: string;
    fillingPressure?: string;
    fillingCapacity?: number;
    fillingCapacityUoM?: string;
    valvePrimary?: string;
    valveSecondary?: string;
    volume?: number;
    isBuyable?: boolean;
    isVisible?: boolean;
    isPreferred?: boolean;
    gasTypeHardware?: string;
    material?: string;
    controlRange?: string;
    connection?: string;
    output?: string;
    EClassVersion?: string;
    EClassCategoryId?: string;
    amountPallet?: number;
    translations?: Items4[];
  }[];
}

export interface SearchResponseType {
  /** @minItems 0 */
  assets: {
    /** Identifier of the entity we are aiming to search a linked asset/document. This can be an invoice id, container id, etc... */
    id?: string;
    /** Identifier of an asset in the final storage system. This can be a doxis document Id, a Azure blob id or similar */
    assetId?: string;
    /** Container or Path where the asset is located. */
    locationReference?: string;
    /** The language code bound to the document */
    language?: string;
    /** The document number */
    documentNumber?: string;
    /** The barcode number */
    barcodeNumber?: string;
    /** The SAP customer number */
    ERPCustomerId?: string;
    /** The type of the document */
    documentType?: string;
    /**
     * The date of the document
     * @format date
     */
    documentDate?: string;
    /** The doxis uuid of the document */
    documentId?: string;
  }[];
}

export interface DownloadRequestSignedURLsType {
  /**
   * Epoch timestamp in milliseconds. Default expiration time is 1 hour.
   * @min 0
   * @example 1720441200000
   */
  expiry?: number;
  /** @minItems 1 */
  assets: {
    assetId: string;
    locationReference: string;
  }[];
}

export interface DownloadResponseSignedUrlsType {
  /** @minItems 0 */
  assets: any[];
}

export interface ProductComponentsRecommendationsRequestType {
  /** @minItems 0 */
  components: Items7[];
  residualGas: string;
  webstoreExternalId: string;
}

export interface ProductComponentsRecommendationsResponseType {
  total: number;
  /** @minItems 0 */
  products: Items8[];
}

export interface BarcodeProductType {
  barcode: string;
  productCode: string;
  plant: string;
}

export interface Items {
  productId: string;
  externalId: string;
  productClass: string;
  externalParentId?: string;
  name?: string;
  family?: string;
  /** @minItems 0 */
  imageURLs?: Items2[];
  description?: string;
  isBuyable?: boolean;
  isVisible?: boolean;
  isPreferred?: boolean;
  EClassVersion?: string;
  EClassCategoryId?: string;
  previewText?: string;
  /** @minItems 0 */
  translations: {
    language: string;
    customName?: string;
    description?: string;
    previewText?: string;
  }[];
}

export interface ProductCategoriesType {
  externalId: string;
  name: string;
  catalogExternalId: string;
  sortOrder?: number;
  isNavigational: boolean;
  numberOfProducts: number;
  externalUrl?: string;
  subcategories?: ProductCategoriesType[];
}

export interface Items1 {
  externalId: string;
  name?: string;
  CASNumber?: string;
}

export interface Items2 {
  imageURL: string;
  isPrimary?: boolean;
}

export interface Items3 {
  categoryId?: string;
  externalId?: string;
  parentCategoryId?: string;
  categoryName?: string;
  isMPCProduct?: boolean;
  translations?: Items4[];
}

export interface Items4 {
  language?: string;
  name?: string;
  customName?: string;
  description?: string;
  typicalApplication?: string;
  previewText?: string;
  summary?: string;
  importantInformation?: string;
  alternativePhysicalDataFreeText?: string;
  additionalComponentInformation?: string;
}

export interface Items5 {
  value: string;
  characteristic: string;
  type: string;
  name: string;
  externalId: string;
}

export interface Items6 {
  type?: string;
  componentGas?: string;
  quantity?: number;
  unitOfMeasure?: string;
  analysisPrecision?: number;
}

export interface SignedUrlSuccess {
  id?: string;
  assetId: string;
  locationReference: string;
  signedUrl: string;
  documentId?: string;
}

export interface SignedUrlError {
  assetId: string;
  error: string;
  documentId?: string;
}

export interface Items7 {
  componentGas: string;
  quantity: number;
  unitOfMeasure: string;
  analysisPrecision?: number;
}

export interface Items8 {
  productId: string;
  productCode: string;
  name: string;
  certificate: string;
  container: string;
  inGGStock?: boolean;
  /** @minItems 1 */
  components: Items6[];
  residualGas: Items1;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<
  D extends unknown,
  E extends unknown = unknown,
> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title wag-exp-hub-guest-api
 * @version 1.0
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  fbs = {
    /**
     * @description Create a new meter-readings
     *
     * @name CreateANewMeterReadings
     * @request POST:/fbs/meter-readings
     */
    createANewMeterReadings: (
      generated: CaptchedMeterReadingRequest,
      params: RequestParams = {},
    ) =>
      this.request<RecordCreated, Type>({
        path: `/fbs/meter-readings`,
        method: "POST",
        body: generated,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsFbs
     * @request OPTIONS:/fbs/meter-readings
     */
    optionsFbs: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/fbs/meter-readings`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * @description Post a new meter reading for a given meter number with up to 2 photos
     *
     * @name PostANewMeterReadingForAGivenMeterNumberWithUpTo2Photos
     * @request POST:/fbs/meter-readings/attachments
     */
    postANewMeterReadingForAGivenMeterNumberWithUpTo2Photos: (
      generated: {
        formData: CaptchedMeterReadingRequest;
        /** @format binary */
        file1: File;
        /** @format binary */
        file2?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<RecordCreated, any>({
        path: `/fbs/meter-readings/attachments`,
        method: "POST",
        body: generated,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new registrations
     *
     * @name CreateANewRegistrations0
     * @request POST:/fbs/registrations
     */
    createANewRegistrations0: (
      generated: RegistrationRequest,
      params: RequestParams = {},
    ) =>
      this.request<RegistrationResponse, Type>({
        path: `/fbs/registrations`,
        method: "POST",
        body: generated,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsFbs2
     * @request OPTIONS:/fbs/registrations
     * @originalName optionsFbs
     * @duplicate
     */
    optionsFbs2: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/fbs/registrations`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * @description Create a new validations
     *
     * @name CreateANewValidations0
     * @request POST:/fbs/registrations/validations
     */
    createANewValidations0: (
      generated: RegistrationValidationsRequest,
      params: RequestParams = {},
    ) =>
      this.request<ActionPostedWithoutNewRecord, Type>({
        path: `/fbs/registrations/validations`,
        method: "POST",
        body: generated,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsFbs3
     * @request OPTIONS:/fbs/registrations/validations
     * @originalName optionsFbs
     * @duplicate
     */
    optionsFbs3: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/fbs/registrations/validations`,
        method: "OPTIONS",
        ...params,
      }),
  };
  gas = {
    /**
     * @description Create a new registrations
     *
     * @name CreateANewRegistrations1
     * @request POST:/gas/registrations
     */
    createANewRegistrations1: (
      generated: RegistrationRequest,
      params: RequestParams = {},
    ) =>
      this.request<RegistrationResponse, Type>({
        path: `/gas/registrations`,
        method: "POST",
        body: generated,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsGas
     * @request OPTIONS:/gas/registrations
     */
    optionsGas: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/gas/registrations`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * @description Create a new validations
     *
     * @name CreateANewValidations1
     * @request POST:/gas/registrations/validations
     */
    createANewValidations1: (
      generated: RegistrationValidationsRequest,
      params: RequestParams = {},
    ) =>
      this.request<ActionPostedWithoutNewRecord, Type>({
        path: `/gas/registrations/validations`,
        method: "POST",
        body: generated,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsGas2
     * @request OPTIONS:/gas/registrations/validations
     * @originalName optionsGas
     * @duplicate
     */
    optionsGas2: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/gas/registrations/validations`,
        method: "OPTIONS",
        ...params,
      }),
  };
  catalogue = {
    /**
     * @description Search products from a store
     *
     * @name SearchProductsFromAStore
     * @request GET:/catalogue/products
     */
    searchProductsFromAStore: (
      query: {
        /** comma separated list of produts represented by their externalId */
        externalIds: string;
        webstoreExternalId: string;
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductSearchResponseType, Type>({
        path: `/catalogue/products`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsCatalogue
     * @request OPTIONS:/catalogue/products
     */
    optionsCatalogue: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/catalogue/products`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * @description retrieve product categories
     *
     * @name RetrieveProductCategories
     * @request GET:/catalogue/products/categories
     */
    retrieveProductCategories: (
      query: {
        webstoreExternalId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductCategoriesResponse, Type>({
        path: `/catalogue/products/categories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsCatalogue2
     * @request OPTIONS:/catalogue/products/categories
     * @originalName optionsCatalogue
     * @duplicate
     */
    optionsCatalogue2: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/catalogue/products/categories`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * @description retrieve product substances
     *
     * @name RetrieveProductSubstances
     * @request GET:/catalogue/products/substances
     */
    retrieveProductSubstances: (params: RequestParams = {}) =>
      this.request<ProductSubstancesResponseType, Type>({
        path: `/catalogue/products/substances`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsCatalogue3
     * @request OPTIONS:/catalogue/products/substances
     * @originalName optionsCatalogue
     * @duplicate
     */
    optionsCatalogue3: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/catalogue/products/substances`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * @description Retrieve a collection of products
     *
     * @name Products
     * @request GET:/catalogue/products/{externalId}
     */
    products: (
      externalId: string,
      query?: {
        language?: string;
        webstoreExternalId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CatalogueProductDetailsType, Type>({
        path: `/catalogue/products/${externalId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsCatalogue4
     * @request OPTIONS:/catalogue/products/{externalId}
     * @originalName optionsCatalogue
     * @duplicate
     */
    optionsCatalogue4: (externalId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/catalogue/products/${externalId}`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * @description Search assets for the given category
     *
     * @name SearchAssetsForTheGivenCategory
     * @request GET:/catalogue/products/{externalId}/assets/{category}
     */
    searchAssetsForTheGivenCategory: (
      externalId: string,
      category: "product-data" | "safety-sheets" | "further-product-documents",
      query?: {
        webstoreExternalId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchResponseType, Type>({
        path: `/catalogue/products/${externalId}/assets/${category}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsCatalogue5
     * @request OPTIONS:/catalogue/products/{externalId}/assets/{category}
     * @originalName optionsCatalogue
     * @duplicate
     */
    optionsCatalogue5: (
      externalId: string,
      category: "product-data" | "safety-sheets" | "further-product-documents",
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/catalogue/products/${externalId}/assets/${category}`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * @description Download assets via signed-urls
     *
     * @name DownloadAssetsViaSignedUrls
     * @request POST:/catalogue/products/{externalId}/assets/{category}/signed-urls/download
     */
    downloadAssetsViaSignedUrls: (
      externalId: string,
      category: "product-data" | "safety-sheets" | "further-product-documents",
      generated: DownloadRequestSignedURLsType,
      params: RequestParams = {},
    ) =>
      this.request<DownloadResponseSignedUrlsType, Type>({
        path: `/catalogue/products/${externalId}/assets/${category}/signed-urls/download`,
        method: "POST",
        body: generated,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsCatalogue6
     * @request OPTIONS:/catalogue/products/{externalId}/assets/{category}/signed-urls/download
     * @originalName optionsCatalogue
     * @duplicate
     */
    optionsCatalogue6: (
      externalId: string,
      category: "product-data" | "safety-sheets" | "further-product-documents",
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/catalogue/products/${externalId}/assets/${category}/signed-urls/download`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * @description Acquire recommendations for specified components
     *
     * @name AcquireRecommendationsForSpecifiedComponents
     * @request POST:/catalogue/products/components/{componentCategory}/recommendations
     */
    acquireRecommendationsForSpecifiedComponents: (
      componentCategory: "gas-mixtures",
      generated: ProductComponentsRecommendationsRequestType,
      params: RequestParams = {},
    ) =>
      this.request<ProductComponentsRecommendationsResponseType, Type>({
        path: `/catalogue/products/components/${componentCategory}/recommendations`,
        method: "POST",
        body: generated,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsCatalogue7
     * @request OPTIONS:/catalogue/products/components/{componentCategory}/recommendations
     * @originalName optionsCatalogue
     * @duplicate
     */
    optionsCatalogue7: (
      componentCategory: "gas-mixtures",
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/catalogue/products/components/${componentCategory}/recommendations`,
        method: "OPTIONS",
        ...params,
      }),
  };
  webstores = {
    /**
     * @description Retrieve the product code associated to the barcode and webstore
     *
     * @name RetrieveTheProductCodeAssociatedToTheBarcodeAndWebstore
     * @request GET:/webstores/{webstoreExternalId}/barcodes/{barcode}
     */
    retrieveTheProductCodeAssociatedToTheBarcodeAndWebstore: (
      barcode: string,
      webstoreExternalId: string,
      params: RequestParams = {},
    ) =>
      this.request<BarcodeProductType, Type>({
        path: `/webstores/${webstoreExternalId}/barcodes/${barcode}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Handle CORS preflight request
     *
     * @name OptionsWebstores
     * @request OPTIONS:/webstores/{webstoreExternalId}/barcodes/{barcode}
     */
    optionsWebstores: (
      barcode: string,
      webstoreExternalId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/webstores/${webstoreExternalId}/barcodes/${barcode}`,
        method: "OPTIONS",
        ...params,
      }),
  };
}
